import Vue from 'vue'
import Team from '../models/team'
import ApiBase from '@/api/apiBase'


class ApiTeams {
  static all(callBack, errorCallBack){
    ApiBase.get(`/teams`, callBack, ApiTeams.parseAll, errorCallBack)
  }

  static parseAll(response){
    var result = []
    for(var i in response.data.data){
      result.push(Team.parse(response.data.data[i]))
    }
    return result
  }


  static find(teamID,callBack, errorCallBack){
    ApiBase.get(`/teams/${teamID}`,callBack,ApiTeams.parseFind,errorCallBack)
  }
  static parseFind(response){
    return Team.parse(response.data.data)
  }

  static create(team,callBack,errorCallBack){
    const formData = new FormData()
    formData.append('name', team.name)
    if(team.imageFile){
      formData.append('image', team.imageFile)
    }
    ApiBase.post(`/teams`, formData, callBack, ApiBase.noParse, errorCallBack)
  }


  static update(team, callBack, errorCallBack){
    const formData = new FormData()
    formData.append('name', team.name)
    if(team.imageFile){
      formData.append('image', team.imageFile)
    }

    ApiBase.post(`/teams/${team.id}`,formData,callBack,ApiTeams.parseUpdate,errorCallBack)
  }

  static associateTeam(teamID, tournamentID, callBack, errorCallBack) {
    const formData = new FormData()
    formData.append('team_id', teamID)
    ApiBase.post(`/tournaments/${tournamentID}/add_team`, formData, callBack, ApiBase.noParse, errorCallBack)
  }

  static removeTeamFromTournament(data, callBack, errorCallBack) {
    ApiBase.get(`/tournaments/${data.tournamentID}/remove_team/${data.teamID}`, callBack, ApiBase.noParse, errorCallBack)
  }

  static unlinkTeam(teamID,callBack,errorCallBack){
    ApiBase.get(`/teams/${teamID}/unlink_team`, callBack, ApiBase.noParse, errorCallBack)
  }

  /*static changeStatus(complex, callBack, errorCallBack){
    let data = {
      "status": complex.status == "active" ? "inactive" : "active",
    }

    ApiBase.put(`/teams/${complex.id}`,data,callBack,ApiTeams.parseUpdate,errorCallBack)
  }*/

static sendTeamLink(teamid,email,callBack,errorCallBack){
  let data = {email:email}
  ApiBase.post(`/teams/${teamid}/send_link_url_email`, data, callBack, ApiBase.noParse, errorCallBack)

}

  static parseUpdate(response){
    return response
  }

  static delete(team, callBack, errorCallBack){
    ApiBase.delete(`/teams/${team.id}`,callBack,ApiBase.noParse,errorCallBack)
  }

}

export default ApiTeams



// WEBPACK FOOTER //
// ./src/api/apiTeams.js